import * as React from 'react';
import './LocationPanel.scss';
import { useTranslation } from 'react-i18next';
import { CountryListStore } from '../../store/CountryList';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Radio, Select, Layout } from '@iba-team/portal-react-components/dist';
import { UnionLocations } from '../../types';
import { useAnalytics, useIsMobile } from '../../utils/hooks';
import { CalendarStore } from '../../store/Calendar';

interface LocationPanelI {
  location?: string
}
export const LocationPanel = observer((props:LocationPanelI) => {
  const { t } = useTranslation();
  const { countryList, getCountryList, location } = CountryListStore;
  const {updateCalendarCountry} = CalendarStore;
  const isMobile = useIsMobile();
  useEffect(() => {
    getCountryList();
  }, [getCountryList]);

  return (
    <div className={'locationPanel'}>
      <Layout header={{layoutName: <h3>{t('locations')}</h3>}} className={'location'}>
        {props.location &&
          <>
            {isMobile ?
              <div className={'select'}>
                <Select
                  uniqueElement={el => el === location}
                  list={countryList}
                  value={props.location}
                  onChangeValue={(value) => updateCalendarCountry(value)}
                  render={(item) => <div>{item}</div>}/>
              </div>
              :
              <div className={'radio_buttons'}>
                {countryList.map((location, index) =>
                  <div key={index} className={'location_item'}>
                    <Radio label={location} value={location}
                      checked={location === props.location}
                      onChange={(event) => {
                        useAnalytics('Calendar', 'change_location', event.target.value);
                        updateCalendarCountry(event.target.value as UnionLocations);
                      }}
                    />
                  </div>
                )}
              </div>
            }
          </>
        }
      </Layout>
    </div>
  );
});
